import { Typography } from 'antd'
import { NotConfiguredProps } from './types'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'

/**
 * @see {@link NotConfiguredProps}
 */
const NotConfigured: React.VFC<NotConfiguredProps> = (props) => {
  const eventName = useCIMSNotificationsPanelContext().event.name
  return props.type === 'every' ? (
    <Typography.Text>
      No Recipients have been configured to receive an email for every{' '}
      {eventName} event, on every Design Submittal
    </Typography.Text>
  ) : (
    <Typography.Text>
      No Recipients have been configured to receive an email for {eventName}{' '}
      events where {props.itemName} is the {props.groupName} of the Design
      Submittal
    </Typography.Text>
  )
}

export default NotConfigured
